import { Route } from "components/Route";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { StudentGroupDetailPage } from "./StudentGroupDetailPage";
import { StudentGroupPage } from "./StudentGroupPage";
import { StudentLeaderboardPage } from "./StudentLeaderboardPage";

export const StudentGroupPageSwitch = (): JSX.Element => (
	<Switch>
		<Route path={routes._.groups._.view._.leaderboard.path}>
			<StudentLeaderboardPage />
		</Route>

		<Route path={routes._.groups._.view.path}>
			<StudentGroupDetailPage />
		</Route>

		<Route path={routes._.groups.path}>
			<StudentGroupPage />
		</Route>
	</Switch>
);
